import { FormMonthRangePicker, FormSelect, Heading, Loader } from "@/components";
import useCloseoutReport from "./useCloseoutReport";
import { Button, Card, CardContent, Label, Switch } from "@/components/ui";
import { activeLevels, allOption, cn } from "@/lib/utils";
import { FormProvider } from "react-hook-form";
import { DISTRIBUTION_LEVEL, GL_MASTER_ID, MONTH_RANGE } from "./consts";
import BudgetReportTable from "./BudgetTable";

const CloseoutReport = () => {
  const {breadcrumbData, isLoadingReportData,
    summaryCards, closeoutTableData,
    isRunClick, formData, currentFinanceYear,
    isActual, onChangeType, form, closeoutReportData,
    glMasterListing, onClear, onSubmit, requiredField,
    isGlMasterLoading, distributionLevel, isLoadingFinancialInfo,
    activeThresholdIndex} = useCloseoutReport();
    const {errors} = form.formState;

  return (
    <div className="p-4">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <Heading title={<span>Level Closeout Report <span className="text-[12px]">(FY-{currentFinanceYear})</span></span>} breadcrumbData={breadcrumbData} />
        <div className="w-full flex items-center justify-end gap-2 h-[38px] mb-5">
          <Label className="text-[14px]">Budget</Label>
          <Switch 
            checked={isActual}
            onCheckedChange={onChangeType}
          />
          <Label className="text-[14px]">Actual</Label>
        </div>
      </div>

      {isLoadingFinancialInfo ? <Loader /> :
        <>
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <Card className="mb-6">
                <CardContent className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[20px]">
                  <FormMonthRangePicker
                    name={MONTH_RANGE}
                    label="Month Range"
                    placeholder="Select Range"
                    control={form.control}
                    onClear={() =>
                      form.setValue(MONTH_RANGE, { from: "", to: "" })
                    }
                    isRequired={requiredField?.includes(`${MONTH_RANGE}.from`) || requiredField?.includes(`${MONTH_RANGE}.to`)}
                    error={(errors[MONTH_RANGE] as any)?.from?.message || (errors[MONTH_RANGE] as any)?.to?.message}
                  />
                  <FormSelect
                    name={GL_MASTER_ID}
                    control={form.control}
                    label="GL Account"
                    placeholder="Please select"
                    multiSelect
                    options={[...allOption, ...(glMasterListing?.glOptions || [])
                      ?.sort((a: any, b: any) =>
                        a.glAccountNumber?.localeCompare(b.glAccountNumber)
                      )
                      ?.map((data: any) => {
                        return {
                          label: `${data?.glAccountNumber} - ${data?.description}`,
                          value: data?.glMasterId?.toString(),
                        };
                      })
                      ?.sort((a: any, b: any) => {
                        return a.disabled === b.disabled
                          ? 0
                          : a.disabled
                          ? 1
                          : -1;
                      })]}
                    isRequired={requiredField?.includes(GL_MASTER_ID)}
                    error={errors[GL_MASTER_ID]?.message}
                    disabled={isGlMasterLoading}
                  />
                  <FormSelect
                    showSearch={false}
                    name={DISTRIBUTION_LEVEL}
                    control={form.control}
                    label="Allocation Level"
                    placeholder="Please select"
                    options={activeLevels.slice(0, activeThresholdIndex + 1)}
                    isRequired={requiredField?.includes(DISTRIBUTION_LEVEL)}
                    error={errors[DISTRIBUTION_LEVEL]?.message}
                  />
                  <div className="flex flex-row items-center gap-5">
                    <Button type="button" variant="outline" onClick={onClear}>Clear</Button>
                    <Button>Search</Button>
                  </div>
                </CardContent>
              </Card>
            </form>
          </FormProvider>
          {isRunClick ? isLoadingReportData ? <Loader /> :
            <>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-[20px] my-5">
                {summaryCards?.map((data: any) => {
                  return (
                    <Card className={cn(data?.hasDescValue ? "bg-red-100" : data?.className)} key={data?.id}>
                      <CardContent className="font-medium text-gray-500 text-[14px] flex flex-col items-center justify-center">
                        <label>{data?.title}</label>
                        <span className="text-[20px] text-black">{data?.total || ""}</span>
                        <label className={cn("text-center", data?.desc?.toLowerCase() != "recorded" ? "text-red-600" : "")}>{data?.desc}</label>
                      </CardContent>
                    </Card>
                  )
                })}
              </div>
              <BudgetReportTable
                data={(closeoutTableData || []) as any} 
                level={distributionLevel || ""}
                filter={{year: currentFinanceYear, ...formData}}
                totalData={closeoutReportData}
              />
            </>
            : <></>
          }
        </>
      }
    </div>
  )
}

export default CloseoutReport;
